<template>
  <div class="vi-school-overview">
    <main v-if="schoolData">
      <!-- ======= Search Section ======= -->
      <div class="web-resfound p-2">
        <button class="btn web-backbtn" v-if="isPayment == 'paidVersion'" @click="$router.go(-1)">
          <v-icon name="arrow-left" />
          <span class="bck" style="display:none">Back</span>
        </button>
        <div class="container ">
          <div class="row">
            <div class="col-md-3 text-center mt-3 imgresp">
               <img width="200" height="120" v-if="schoolData.image && schoolData.image.path"
                        :src="schoolData.image.path"
                        :alt="schoolData.accountName"
                        :title="schoolData.accountName"
                />
                <img  width="200" height="160" v-else src="../../assets/img/noimage.png" alt="Avatar">
                <!-- <img 
                  :src="schoolData.image"
                  :alt="schoolData.accountName"
                  :title="schoolData.accountName"
                /> -->
             
            </div>
            <div class="col-md-9 web-schnamecont mt-md-3 mt-sm-3">
              <h4>
                <strong
                  >{{ schoolData.accountName }}</strong
                >
              </h4>
              <p>
                <span
                  ><i
                    class="fa fa-map-marker fa-lg"
                    aria-hidden="true"
                  ></i></span
                >
                {{ schoolData.street ? schoolData.street : '' }},{{ schoolData.city ? schoolData.city : '' }},{{ schoolData.district ? schoolData.district : '' }},{{ schoolData.state ? schoolData.state : '' }},{{ schoolData.pincode ? schoolData.pincode : '' }}
              </p>
              <p>
                <span><i class="fa fa-envelope" aria-hidden="true"></i></span
                ><a>{{ schoolData.email }}</a>
              </p>
              <p>
                <span
                  ><i class="fa fa-phone-square" aria-hidden="true"></i></span
                >{{ schoolData.landlineNo ? schoolData.landlineNo : ''  }}
              </p>
              <div class="web-admbtn">
                <a
                  class="btn web-custbtn web-rounded-xl h-100 btn-3 "
                  style="width:225px"
                  >{{ checkAdmissionAuvaiable > 0 ? 'Admission Open Now' : 'Admission Closed' }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="web-filterbg pl-3 pr-3 m-0" id="filtersects">
        <div class="container-fluid">
          <div class="row">
            <div class="offset-md-3 web-mobnav">
              <nav class=" vertical-align-middle scroll ml-2">
                <ul
                  v-scroll-spy-active="{ class: 'tabactive' }"
                  v-scroll-spy-link
                >
                  <li><a>Overview</a></li>
                  <li><a>Seat Availability</a></li>
                  <li><a>Admission Process</a></li>
                  <li><a>Facilities</a></li>
                  <li><a>Contact Details</a></li>
                  <li><a>Branches</a></li>

                  <li><a>Gallery</a></li>
                  <li><a>Rating & Reviews</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="web-innerpagecont py-3 pl-3 pr-3">
        <div class="container-fluid">
          <div class="row web-row-flex">
            <!-- <div class="col-md-3 col-sm-6">
              <p><strong>Place for Google ad</strong></p>
            </div> -->
            <div class="col-md-12 col-sm-12" style="margin-left: 64px;
    flex: 0 0 100%;
    max-width: 90%;">
              <div v-scroll-spy="{ data: 'section', offset: 120 }">
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection">
                      <img
                        src="../../assets/img/school_info_icon.svg"
                        width="99%"
                        alt="Overview"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Overview</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    
                   <p :style="overviewHight == true ? 'overflow: hidden;' : 'height: 84px;overflow: hidden;'">
                     <!-- <span v-if="schoolData.overView.length  65">  -->
                     {{ schoolData.overView }} 
                   <!-- </span> -->
                    </p>
                    
                    <a v-if="!overviewHight && schoolData.overView && schoolData.overView.length > 540" href="javascript:void(0);" style="margin-left: 39%;" @click="increaseOverViewheight">Read More</a>
                   <a v-if="overviewHight && schoolData.overView && schoolData.overView.length > 540" href="javascript:void(0);" style="margin-left: 39%;" @click="reduceOverViewheight">Read Less</a>
                  </div>
                   <!-- <a v-if="!overviewHight" href="javascript:void(0);" style="margin-left: 39%;" @click="increaseOverViewheight">Read More</a>
                   <a v-if="overviewHight" href="javascript:void(0);" style="margin-left: 39%;" @click="reduceOverViewheight">Read Less</a> -->
                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection">
                      <img
                        src="../../assets/img/seatsavailicn.svg"
                        width="99%"
                        alt="Seats Availability"
                        title="Seats Availability"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Seats Availability</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col" style="text-align:center">Class Details</th>
                          <th scope="col" style="text-align:center">No. of Seats</th>
                          <th scope="col" style="text-align:center">No. of Seats Available</th>
                          <th scope="col" style="text-align:center">Admission Status</th>
                          <th scope="col" style="text-align:center">Annual Fees</th>
                          <th scope="col" style="text-align:center">Admission Fees</th>
                          <th scope="col" style="text-align:center">Online</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr  v-for="(fee, index) in admissionDetails" :key="index">
                          <td data-label="Class Details" style="text-align:center">{{ fee.class ? fee.class.className : '' }}</td>
                          <td data-label="No. of Seats" style="text-align:center">{{ fee.noOfSeats }}</td>
                          <td data-label="No. of Seats" style="text-align:center">{{ fee.seatsAvailable }}</td>
                          <td data-label="No. of Seats" style="text-align:center">{{ fee.admissionStatus }}</td>
                          <td data-label="Total Fees" style="text-align:center">{{ fee.amount }} </td>
                          <td data-label="Total Fees" style="text-align:center">{{ fee.admissionFees || '-' }} </td>
                          <td data-label="Apply Now" style="text-align:center">
                             <a  href="javascript:void();" class="web-applynow" v-if="fee.amount && fee.admissionStatus == 'Open' " @click.prevent="applyAdmissionOnline(index)">
                              <img 
                                style="background-color: yellowgreen;border-radius: 30px;"
                                src="../../assets/img/handcursoricn.svg"
                                
                                alt="apply now"
                                title="Apply Now"
                              />
                            </a>
                             <a  href="javascript:void();" class="web-notapply" v-else >
                             <img 
                                style="cursor: not-allowed;border-radius: 30px;"
                                src="../../assets/img/notapply.svg"
                               
                                alt="Admission Closed"
                                title="Admission Closed"
                              />
                            </a>
                             
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection" style="padding:6px">
                      <img
                        src="../../assets/img/admissionicn.svg"
                        width="99%"
                        alt="Vidhyaan Admission Process"
                        title="Vidhyaan Admission Process"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Admission Process</h1>
                    </div>
                  </div>
                 

                  <div class="nottble p-3 dispflex" style="justify-content: normal">
                    
               <div class="chkbox" data-title="Select" style="width: 20%;">
                  <label class="custcheckbox">
                    <input type="checkbox" disabled v-model="schoolData.isOnlineAdmission" />
                    <span class="checkmarkchk" ></span>
                    
                  </label>
                  <label style="margin-left:35px">Online Admission</label>
                </div>

                <div class=" chkbox" data-title="Select" style="width: 20%;">
                  <label class="custcheckbox">
                    <input type="checkbox" disabled v-model="schoolData.isOfflineAdmission"/>
                    <span class="checkmarkchk"></span>
                    
                  </label>
                  <label style="margin-left:35px">Offline Admission</label>
                </div>
                  </div>

                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection" style="padding:6px">
                      <img
                        src="../../assets/img/facilitiesicn.svg"
                        width="99%"
                        alt="Facilities"
                        title="Facilities"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Facilities</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    <p>
                      The school facility consists of not just the physical
                      structure such as plumbing, mechanical, electrical,
                      telecommunications, security, fire prevention and
                      suppression systems, and the various building systems, but
                      it also includes furnishing, materials and supplies,
                      equipment and information technology. Basic facilities we
                      have in our schools like,
                    </p>
                    <div class="web-dispflex">
                      <div class="web-colwidth mb-4 colcent">
                        <span class="web-facicn">
                          <img
                            class="img-fluid"
                            src="../../assets/img/school_icn.png"
                            width="56"
                          />
                        </span>
                        <span class="web-factxt">
                          <p>Type of School</p>
                          <span>{{ schoolData.schoolType }}</span>
                        </span>
                      </div>
                      <div class="web-colwidth mb-4 colcent">
                        <span class="web-facicn">
                          <img
                            class="img-fluid"
                            src="../../assets/img/afflilation_icn.png"
                            width="56"
                          />
                        </span>
                        <span class="web-factxt">
                          <p>Examination Board</p>
                          <span>{{ schoolData.affilliateIdToBoard.toString()}}</span>
                        </span>
                      </div>
                      <div class="web-colwidth mb-4 colcent">
                        <span class="web-facicn">
                          <img
                            class="img-fluid"
                            src="../../assets/img/fees_icn.png"
                            width="56"
                          />
                        </span>
                        <span class="web-factxt">
                          <p>Annual Fees</p>
                          <span
                            >Start from Rs. {{ schoolData.lowestFees }}</span
                          >
                        </span>
                      </div>
                      <div class="web-colwidth mb-4 colcent">
                        <span class="web-facicn">
                          <img
                            class="img-fluid"
                            src="../../assets/img/lang_icn.png"
                            width="56"
                          />
                        </span>
                        <span class="web-factxt">
                          <p>Language of Instruction</p>
                          <span>{{ schoolData.medium.toString() }}</span>
                        </span>
                      </div>
                      <div
                        class="web-colwidth mb-4 colcent"
                        v-for="(fitem, index) in schoolData.facilities"
                        :key="index"
                      >
                        <span class="web-facicn">
                          <img
                            class="img-fluid"
                            :src="`${facilitiesURL}/${fitem.icon}.svg`"
                            width="56"
                          />
                        </span>
                        <span class="web-factxt">
                          <p>{{ fitem.name }}</p>
                          <span>Yes</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection" style="padding:10px">
                      <img
                        src="../../assets/img/contactdetailsicon.svg"
                        width="99%"
                        alt="Contact Details"
                        title="Contact Details"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Contact Details</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    <div class="form-row">
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3" v-if="schoolData.email">
                        <span class="web-has-float-label" style="flex-grow:0">
                          <label for="email">Email</label>
                        </span>
                        <div
                          style="padding-top:9px;width:100%;border-bottom:1px solid #e5e5e5"
                        >
                          <a href="mailto:info@velammal.org"
                            >{{ schoolData.email }}</a
                          >
                        </div>
                      </div>
                      <div class="form-group input-group col-md-6 mt-3" v-if="schoolData.landlineNo">
                        <span class="web-has-float-label" style="margin:1px">
                          <label for="phno">Phone</label>
                        </span>
                        <div
                          style="padding-top:9px;width:100%;border-bottom:1px solid #e5e5e5"
                        >
                          +91 {{ schoolData.landlineNo }}
                        </div>
                      </div>
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3" v-if="schoolData.website">
                        <span class="web-has-float-label" style="flex-grow:0">
                          <label for="website">Website</label>
                        </span>
                        <div
                          style="padding-top:9px;width:100%;border-bottom:1px solid #e5e5e5"
                        >
                          <!-- <a v-if="schoolData.website"
                            href="http://www.velammal.org/velammal-vidhyashram-mambakkam/"
                            target="_blank"
                            >{{ schoolData.website }}</a
                          > -->
                        </div>
                      </div>
                      <div class="form-group input-group col-md-6 mt-3" v-if="schoolData.location">
                        <span class="web-has-float-label" style="margin:1px">
                          <label for="location">Location</label>
                        </span>
                        <div
                          style="padding-top:9px;width:100%;border-bottom:1px solid #e5e5e5"
                        >
                          {{ schoolData.location }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection" style="padding:10px">
                      <img
                        src="../../assets/img/contactdetailsicon.svg"
                        width="99%"
                        alt="Contact Details"
                        title="Contact Details"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1> Branches</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    <div v-if="filteredSchool.length > 0">
                      <div
                id="schlistcont"
                v-for="(item, index) in filteredSchool"
                :key="index"
              >

                <div class="web-whitebg mb-5 web-dispflex wow web-fadeInUp" style="background: #f5f5f5;">
                  <div class="web-left_item">
                    <div class="web-shcimg" style="width: 97% !important;">
                      <img
                        v-if="item.image && item.image.path"
                        :src="item.image.path"
                        :alt="item.accountName"
                        :title="item.accountName"
                      />
                      <img
                        v-else
                        src="../../assets/img/noimage.png"
                        alt="Avatar"
                      />
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="web-orgbtn"
                      v-if="item.isAdmissionAvailable"
                      >Admission Open Now</a
                    >
                    <!-- <div class="web-verified" v-if="item.isVerified">
                      <img
                        src="../../assets/img/verified.png"
                        alt="Vidhyaan web-verified"
                        title="web-verified"
                      />
                    </div> -->
                  </div>
                  <div class="web-right_item wow">
                    <div class="web-dispflex mb-2">
                      <div>
                        <h4>{{ item.accountName }}</h4>
                        <p>
                          {{ item.street ? item.street : '' }},{{ item.city ? item.city : '' }},{{ item.district ? item.district : '' }},{{ item.state ? item.state : '' }},{{ item.pincode ? item.pincode : '' }}

                          <!-- <span
                            ><a
                              href="javascript:void(0);"
                              @click.prevent="
                                viewMap(item.latitude, item.longitude)
                              "
                            >
                              <v-icon name="map-marker-alt" /> View on Map</a
                            ></span
                          > -->
                        </p>
                      </div>

                      <div style="margin-left: 15px;">
                        <span
                            ><a
                              href="javascript:void(0);"
                              @click.prevent="
                                viewMap(item.latitude, item.longitude)
                              "
                            >
                              <v-icon name="map-marker-alt" /> View on Map</a
                            ></span
                          >
                       
                      </div>
                      <!-- <div style="margin-left: 15px;">
                        <span
                            ><a
                              href="javascript:void(0);"
                              @click.prevent="
                                viewMap(item.latitude, item.longitude)
                              "
                            >
                             View School</a
                            ></span
                          >
                       
                      </div> -->

                        <!-- <div>
                       <div>
                        <p>School Classification</p>
                        <span>{{ item.classification }}</span>
                      </div>
                      </div> -->

                    </div>
                  <div class="web-dispflex" style="justify-content: normal;">
                        <p>School Type :</p>
                        <span style="margin-top: 2px;margin-left: 6px;font-weight: bold;">{{ item.schoolType }}</span>
                      
                    </div>
                    <div class="web-dispflex " style="justify-content: normal;">
                        <p>School Classification :</p>
                        <span style="margin-top: 2px;margin-left: 6px;font-weight: bold;">{{ item.classification }}</span>
                      
                    </div>
                    <div class="web-dispflex " style="justify-content: normal;">
                        <p>Board :</p>
                        <span style="margin-top: 2px;margin-left: 6px;font-weight: bold;">{{ item.affilliateIdToBoard | capitalize }}</span>
                      
                    </div>
                      <div class="web-dispflex" style="justify-content: normal;">
                     
                        <p>Medium :</p>
                        <span style="margin-top: 2px;margin-left: 6px;font-weight: bold;">{{ item.medium | capitalize }}</span>
                     
                    
                    </div>
                      <div class="web-dispflex" style="justify-content: normal;">
                      
                       
                        <p>Website :</p>
                        <span style="margin-top: 2px;margin-left: 6px;"
                          ><a :href="item.website" target="_blank">{{
                            item.website | removeURLPrefix
                          }}</a></span
                        >
                     
                      <!--<div>
										<button type="submit" class="web-custbutton" >View School</button>
									</div>-->
                    </div>
                    <div class="web-dispflex web-faci" style="justify-content: normal;">
                     
                     <p style="margin-top: 6px;">Facilities :</p>
                     <span style="margin-top: 2px;margin-left: 6px;font-weight: bold;">
                    
                      <ul>
                          <li
                            v-for="(fitem, i) in item.facilities"
                            :key="i"
                            class="web-tooltipt"
                          >
                            <v-icon :name="fitem.icon"></v-icon
                            ><span class="web-tooltiptext">{{
                              fitem.name | capitalize
                            }}</span>
                          </li>
                        </ul>
                    </span>
                  
                 
                 </div>
                    <div class="web-dispflex mb-2 web-faci mb-4">
                      <!-- <div v-if="item.facilities && item.facilities.length > 0">
                        <p>Facilities</p>
                        <ul>
                          <li
                            v-for="(fitem, i) in item.facilities"
                            :key="i"
                            class="web-tooltipt"
                          >
                            <v-icon :name="fitem.icon"></v-icon
                            ><span class="web-tooltiptext">{{
                              fitem.name | capitalize
                            }}</span>
                          </li>
                        </ul>
                      </div> -->
                      <div v-if="item.lowestFees">
                        <p>Starting Fees</p>
                        <span class="fees"
                          ><strong>Rs.{{ item.lowestFees }}</strong></span
                        >
                      </div>
                    </div>
                  </div>
                  <!--<div class="web-enrollbtn "><a href="javascript:void(0);" class="mr-3">Enroll your Kid</a> | <a href="javascript:void(0);" class="ml-3">View School</a></div>-->
                  <div
                    class="btn-group web-enrollbtn wow web-fadeIn"
                    role="group"
                    aria-label="Basic example"
                  >
                    <!-- <button
                      type="button"
                      class="btn btn-secondary btngroupleft"
                    >
                      Enroll your Kid
                    </button> -->
                    <button
                      type="button"
                      class="btn btn-secondary" style="background-color: #08355c !important;"
                      @click.prevent="viewSchoolAction(item)"
                    >
                      View School
                    </button>
                  </div>
                </div>
                <!-- <a style="padding-left: 25%;">View more branches of Columbia City High School</a> -->

              </div>
                     
                  </div>
                  <div v-else>
                    <div class="row" >				
                      <div class="col-lg-12" style="text-align: center;">
                        No branches
                      </div>
                    </div>
                    <!-- <span> </span> -->
                  </div>
                  </div>
                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection" style="padding:10px">
                      <img
                        src="../../assets/img/reviewicn.svg"
                        width="99%"
                        alt="Gallery"
                        title="Gallery"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Gallery</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    <div class="web-dispflex">
                     
                      <div style="margin-right:10px;"
                        
                        v-for="(item, index) in galleryList"
                        :key="index"
                      >
                        <div class="galcontainer">
                          <img style="width:150px;height:150px;"
                            :src="item.path"
                           
                            alt="Avatar"
                            class="mt-3 galimage"
                          />
                        
                        </div>
                     
                      </div>
                    </div>
                   
                    
                  </div>
                </div>
                <div class="web-schovw_whitebg mb-5 wow web-fadeInUp">
                  <div class="web-headercont">
                    <div class="web-iconsection" style="padding:10px">
                      <img
                        src="../../assets/img/reviewicn.svg"
                        width="99%"
                        alt="Ratings & Reviews"
                        title="Ratings & Reviews"
                      />
                    </div>
                    <div class="web-titlesection">
                      <h1>Ratings & Reviews</h1>
                    </div>
                  </div>
                  <div class="p-3">
                    <div class="web-dispflex rating">
                      <div class="web-colwidth">
                        <p><strong>Review by Parents</strong></p>
                        <hr />
                        <div class="web-dispflex">
                          <div>
                            <p>
                              <label>School Infrastructure: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="true"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="parentReview.infrastructure"
                                class="vi-r-review"
                              />
                            </p>
                             <p>
                              <label>School Management: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="parentReview.management"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                           
                            <p>
                              <label>Extra Curricular: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="parentReview.sports"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            <p>
                              <label>Lab Facilities: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="parentReview.facilities"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            <p>
                              <label>Safety: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="parentReview.safety"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                             <p>
                              <label>Faculty: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="parentReview.faculty"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            
                            
                          </div>
                          <div class="web-overall">
                            <p>{{ parentReview | averageRating }}</p>
                            <p>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="0.5"
                                :rating="parentReview | averageRating"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            <p>(Over All) </p>
                          </div>
                        </div>
                      </div>
                      <div class="web-colwidth">
                        <p><strong>Review by Vidhyaan</strong></p>
                        <hr />
                        <div class="web-dispflex">
                          <div>
                            <p>
                              <label>School Infrastructure: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                
                                :rating="adminReview.infrastructure"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                             <p>
                              <label>School Management: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="adminReview.management"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                           
                            <p>
                              <label>Extra Curricular: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="adminReview.sports"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            <p>
                              <label>Lab Facilities: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="adminReview.facilities"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            <p>
                              <label>Safety: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="adminReview.safety"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                             <p>
                              <label>Faculty: </label>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :increment="1"
                                :rating="adminReview.faculty"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            
                            
                          </div>
                          <div class="web-overall">
                            <p>{{ adminReview | averageRating }}</p>
                            <p>
                              <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :rating="adminReview | averageRating"
                                :increment="0.5"
                                :read-only="true"
                                class="vi-r-review"
                              />
                            </p>
                            <p>(Over All)</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="web-dispflex mt-3" v-if="parentReviewList.length > 0">
                      <div class="web-colwidth rating" style="border:0">
                        <h3>Write a Review</h3>
                        <div class="widjetcontent">
                <div class="kidswrapper p-3">
                  <div class="row">
                    <div class="col-12" v-for="(data, index) in parentReviewList" :key="index" >
                      <div class="kids-details-box mb-3" v-if="index == 0 || index == 1 || index == 2">
                        <div
                          class="has-float-label"
                          
                        >
                          <div class="schlogo">
                            
                             <div class="white-box" >
                              <div class="no-blu no-cirlce">
                                            {{ data.parent ? data.parent.firstName.charAt(0) : "" }}{{ data.parent ? data.parent.lastName.charAt(0) : "" }}
                              </div>
                             </div>
                            
                            
                         
                          </div>
                        </div>
                        
                        <div class="item-content">
                          <table class="table text-nowrap">
                            <tbody>
                              <tr>
                                <td>Name:</td>
                                <td >
                                 {{ data.parent.firstName }}
                                </td>
                               
                              </tr>
                              <tr>
                                <td>Date:</td>
                                <td >
                                 {{ data.updatedDate | dateFormat }}
                                </td>
                               
                              </tr>
                              <tr>
                                <td>Ratings:</td>
                                <td >
                                  <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :rating="data.overAllRating"
                                :increment="0.5"
                                :read-only="true"
                                class="vi-r-review"
                              />
                                </td>
                               
                              </tr>
                             
                              
                             
                              <tr>
                                <td>Comments</td>
                                <td>{{ data.comment }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  <button style="width: 37%;margin-left: 88%;"
            type="button"
            class="btn btnsml"
            id="svbtn"
             v-b-modal.reviewPopUp
            v-if="parentReviewList.length > 3"
          >
            <i class="far fa-save"></i> <span>More Reviews</span>
          </button>
                </div>
              </div>
                      </div>
                     
                    </div>
              </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- <vi-spinner
      v-else
      text="Loading..."
      textColor="vi-brand-color"
      class="flex-fill h-100 vi-fs12"
      style="width: 100%;z-index: 111;top:0;left:0;background-color: #fff;bottom:0;right:0;"
    /> -->
    <b-modal id="addstudpop" class="modal" no-close-on-backdrop no-close-on-esc>
      <button type="button" class="close"  @click.prevent="closePoup">×</button>

      <div class="contact-form">
        <h2>Online Admission</h2>
        <br />
        <div>
          <div class="p-3 widjetcontent">
              <div class="subOnetabs" style="height: 2%; background: none">
                <input
                  type="radio"
                  name="subOnetabs"
                  @click="setPopUpActiveTab(1)"
                  id="stdSect"
                  :checked="currentPopUpTab == 1 ? 'checked' : ''"
                />
                <label
                  for="stdSect"
                  style="
                    border: 1px solid rgb(192, 196, 233);
                    border-radius: 15px 15px 0px 0px;
                  "
                  >Student Information <span class="required">*</span></label
                >
                <div class="tab">
                  <div style="height: 350px; overflow-y: auto">
                  <form
                    data-vv-scope="studentvalidateOne"
                    id="stuprofile"
                    accept-charset="utf-8"
                  >
                    <div class="form-row">
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            v-validate="'required'"
                            name="studentFirstName"
                            v-model="contactDetails.firstName"
                            class="form-control form-input"
                            id="stdFirstName"
                          />
                          <label
                            v-if="errors.first('studentvalidateOne.studentFirstName')"
                            class="vi-error"
                            style="top: -1em"
                            >First name is required</label
                          >
                          <label for="stdFirstName" v-else
                            >First Name <span class="required">*</span></label
                          >
                        </span>
                      </div>

                      <div class="form-group input-group col-md-6 mt-3">
                        <span class="has-float-label">
                          <input
                            v-validate="'required'"
                            type="text"
                            name="studentLastName"
                            v-model="contactDetails.lastName"
                            class="form-control form-input"
                            id="stdLastName"
                          />
                          <label
                            v-if="errors.first('studentvalidateOne.studentLastName')"
                            class="vi-error"
                            style="top: -1em"
                            >Last name is required</label
                          >
                          <label for="stdLastName" v-else
                            >Last Name<span class="required">*</span></label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="stdEmail"
                            v-model="contactDetails.email"
                            class="form-control form-input"
                            id="stdEmail"
                          />
                          <label for="stdEmail">Secondary Email</label>
                        </span>
                      </div>
                    
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            v-validate="'required'"
                            type="date"
                            onkeydown="return false"
                            name="DOB"
                            v-model="contactDetails.dob"
                            class="form-control form-input"
                            id="stdDob"
                          />
                          <label
                            v-if="errors.first('studentvalidateOne.DOB')"
                            class="vi-error"
                            style="top: -1em"
                            >Date of birth is required</label
                          >

                          <label for="stdDob" v-else
                            >Date of Birth <span class="required">*</span></label
                          >
                        </span>
                      </div>

                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <select
                            v-validate="'required'"
                            name="Blood Group"
                            class="form-control form-input"
                            id="bloodGroup"
                            v-model="contactDetails.bloodGroup"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(blood, index) in bloodGroupList"
                              :key="index"
                              :value="blood"
                            >
                              {{ blood }}
                            </option>
                          </select>
                          <label
                            v-if="errors.first('studentvalidateOne.Blood Group')"
                            class="vi-error"
                            style="top: -1em"
                            >Blood group is required</label
                          >
                          <label for="bloodGroup" v-else
                            >Blood Group <span class="required">*</span></label
                          >
                        </span>
                      </div>
                    

                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <select
                            v-validate="'required'"
                            name="gender"
                            class="form-control form-input"
                            id="gender"
                            v-model="contactDetails.gender"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(item, index) in genderList"
                              :key="index"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                          <label
                            v-if="errors.first('studentvalidateOne.gender')"
                            class="vi-error"
                            style="top: -1em"
                            >Gender is required</label
                          >
                          <label for="firstName" v-else
                            >Gender <span class="required">*</span></label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                    type="text"
                    disabled
                    name="studentFirstName"
                    v-model="contactDetails.className"
                    class="form-control form-input"
                    id="stdFirstName"
                  />
                          <!-- <select
                            class="form-control form-input"
                            id="deptlistid"
                            v-model="contactDetails.class"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(item, index) in classList"
                              :key="index"
                              :value="item._id"
                            >
                              {{ item.className }}
                            </option>
                          </select> -->

                          <label for="stdFirstName"
                            >Class <span class="required">*</span></label
                          >
                        </span>
                      </div>
                      
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="studentMobileNumber"
                            v-model="contactDetails.studentPhoneNumber"
                            class="form-control form-input"
                            id="stdFirstName"
                          />
                          
                          <label for="stdFirstName" 
                            >Student Mobile Number </label
                          >
                        </span>
                      </div>

                      <div class="form-group input-group col-md-6 mt-3">
                        <span class="has-float-label">
                          <input
                          
                            type="text"
                            name="studentLastName"
                            v-model="contactDetails.placeofBirth"
                            class="form-control form-input"
                            id="stdLastName"
                          />
                        
                          <label for="stdLastName" 
                            >Place Of Birth </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="stdEmail"
                            v-model="contactDetails.otherLanguage"
                            class="form-control form-input"
                            id="stdEmail"
                          />
                          <label for="stdEmail">Other Spoken Language's</label>
                        </span>
                      </div>
                    
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="stdEmail"
                            v-model="contactDetails.aadharNo"
                            class="form-control form-input"
                            id="stdEmail"
                          />
                          <label for="stdDob" 
                            >Aadhar Card Number </label
                          >
                        </span>
                      </div>

                      
                      
                    </div>
                  
                  </form>
                
          </div>
          <div>
               
               <div class="text-center dk_iconsml">
                 <button
                   type="button"
                   class="btn btnsml"
                   id="svbtn"
                   @click.prevent="submitApplication"
                 >
                   <span>Next</span>
                 </button>
                 <!-- <button
                   type="button"
                   @click.prevent="closeAdmissionPoup"
                   class="btn btncl clsmdl"
                   id="clbtn"
                 >
                   <span>Cancel</span>
                 </button> -->
               </div>
             </div>
                </div>
               
                <input
                  type="radio"
                  :disabled="!contactDetails._id"
                  :style="!contactDetails._id ? 'cursor: not-allowed' : ''"
                  :checked="currentPopUpTab == 3 ? 'checked' : ''"
                  @click="setPopUpActiveTab(3)"
                  name="tabs"
                  id="contsec"
                />
                <label
                  for="contsec"
                  :style="!contactDetails._id ? 'cursor: not-allowed;background-color: #f1f3f5;border: 1px solid rgb(192, 196, 233);border-radius: 15px 15px 0px 0px;' : 'border: 1px solid rgb(192, 196, 233);border-radius: 15px 15px 0px 0px;'"

                  >Address Details
                </label>
                <div class="tab">
                  <div style="height: 350px; overflow-y: auto">
            <form
              data-vv-scope="studentvalidate"
              id="stuprofile"
              accept-charset="utf-8"
            >
             
              <div class="form-row">
                     <span style="width: 100%;" class="pl-1 my-2">
                                  <strong>Current Address</strong> &nbsp;
                                  &nbsp;

                                 
                                </span>
                    <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.addressOne"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Address Line 1"
                          />
                          <label for="occid"
                            >Address Line 1 </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.addressTwo"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Address Line 2"
                          />
                          <label for="occid"
                            >Address Line 2 </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.country"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Country"
                          />
                          <label for="occid"
                            >Country</label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <select
                            name="gendddfddder"
                            class="form-control form-input"
                            id="gedfdnder"
                            v-model="contactDetails.state"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(item, index) in stateList"
                              :key="index"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>

                         
                          <label for="occid"
                            >State </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.district"
                            class="form-control form-input"
                            id="occid"
                            placeholder="City/Town"
                          />
                          <label for="occid"
                            >City/Town</label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.postalCode"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Pin Code"
                          />
                          <label for="occid"
                            >Pin Code</label
                          >
                        </span>
                      </div>
                      <!-- <span style="width: 100%;" class="pl-1 my-2">
                                 

                                  <span style="color: #6c757d" class="ml-3"
                                    >Permanent address same as current address ?
                                    </span
                                  >
                                  <input
                                    @change="setPermentAddress(contactDetails.isPermentAddress)" v-model="contactDetails.isPermentAddress"
                                    type="checkbox"
                                  />
                                </span>
                      -->
                    
                  </div>
                  <div class="form-row" >
                  <div
                            class="form-group input-group col-md-6 mt-3"
                            
                          >
                             
                             

                               <div class="nottble" style="margin-top:0px;">
                                <div class=" chkbox" data-title="Select">
                                    <label class="custcheckbox">
                                      <input  type="checkbox" @change="setPermentAddress(contactDetails.isPermentAddress)" v-model="contactDetails.isPermentAddress" />
                                      <span class="checkmarkchk"></span>
                                    </label>
                                  </div>
                                  
                                </div>
                                <span style="margin-left: 35px;">  Permanent address same as current address ?</span>
                               
                                 
                            
                          </div>
                           </div>
                  <div class="form-row" v-if="!contactDetails.isPermentAddress">
                     <span style="width: 100%;" class="pl-1 my-2">
                                  <strong>Permanent Address</strong> &nbsp;
                                  &nbsp;

                                 
                                </span>
                    <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.permentaddressOne"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Address Line 1"
                          />
                          <label for="occid"
                            >Address Line 1 </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.permentaddressTwo"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Address Line 2"
                          />
                          <label for="occid"
                            >Address Line 2 </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.permentcountry"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Country"
                          />
                          <label for="occid"
                            >Country</label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <select
                            name="gendddfddder"
                            class="form-control form-input"
                            id="gedfdnder"
                            v-model="contactDetails.permentstate"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(item, index) in stateList"
                              :key="index"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>

                        
                          <label for="occid"
                            >State </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.permentdistrict"
                            class="form-control form-input"
                            id="occid"
                            placeholder="City/Town"
                          />
                          <label for="occid"
                            >City/Town</label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-4 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            v-model="contactDetails.permentpostalCode"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Pin Code"
                          />
                          <label for="occid"
                            >Pin Code</label
                          >
                        </span>
                      </div>
                    
                     
                    
                  </div>
              
            </form>
          </div>
          <div>
               
               <div class="text-center dk_iconsml">
                 <button
                   type="button"
                   class="btn btnsml"
                   id="svbtn"
                   @click.prevent="saveContactAddress"
                  
                 >
                   <span>Next</span>
                 </button>
                
               </div>
             </div>
                </div>
                <input
                  type="radio"
                  :checked="currentPopUpTab == 4 ? 'checked' : ''"
                  :style="!contactDetails._id ? 'cursor: not-allowed' : ''"
                  :disabled="!contactDetails._id"
                  @click="setPopUpActiveTab(4)"
                  name="tabs"
                  id="acdsec"
                />
                <label
                  for="acdsec"
                  :style="!contactDetails._id ? 'cursor: not-allowed;background-color: #f1f3f5;border: 1px solid rgb(192, 196, 233);border-radius: 15px 15px 0px 0px;' : 'border: 1px solid rgb(192, 196, 233);border-radius: 15px 15px 0px 0px;'"

                  >Academic And background</label
                >
                <div class="tab">
                  <div style="height: 350px; overflow-y: auto">
            <form
              data-vv-scope="studentvalidate"
              id="stuprofile"
              accept-charset="utf-8"
            >
            <div class="form-row">
                <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="stdEmail"
                      v-model="contactDetails.previousSchool"
                      class="form-control form-input"
                      id="stdEmail"
                    />
                    <label for="stdEmail">Last or Current School Name</label>
                  </span>
                </div>
                <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="stdEmail"
                      v-model="contactDetails.lastSchoolGrade"
                      class="form-control form-input"
                      id="stdEmail"
                    />
                    <label for="stdEmail">Last or Current Grade</label>
                  </span>
                </div>
                <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="stdEmail"
                      v-model="contactDetails.lastSchoolCity"
                      class="form-control form-input"
                      id="stdEmail"
                    />
                    <label for="stdEmail">School City</label>
                  </span>
                </div>
                <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="stdEmail"
                      v-model="contactDetails.lastSchoolCountry"
                      class="form-control form-input"
                      id="stdEmail"
                    />
                    <label for="stdEmail">School Country</label>
                  </span>
                </div>
              </div>
             
             
            </form>
          </div>
          <div >
               
               <div class="text-center dk_iconsml">
                 <button
                   type="button"
                   class="btn btnsml"
                   id="svbtn"
                  @click="saveLastAcademicDetails"
                 >
                   <span>Next</span>
                 </button>
                
               </div>
             </div>
                </div>
                <input
                  type="radio"
                  :checked="currentPopUpTab == 5 ? 'checked' : ''"
                  :style="!contactDetails._id ? 'cursor: not-allowed' : ''"
                  :disabled="!contactDetails._id"
                  @click="setPopUpActiveTab(5)"
                  name="tabs"
                  id="upldSec"
                />
                <label
                  for="upldSec"
                  :style="!contactDetails._id ? 'cursor: not-allowed;background-color: #f1f3f5;border: 1px solid rgb(192, 196, 233);border-radius: 15px 15px 0px 0px;' : 'border: 1px solid rgb(192, 196, 233);border-radius: 15px 15px 0px 0px;'"

                  >Documents
                </label>
                <div class="tab">
                  <div class="form-group row" v-for="(data, index) in contactDetails.eligibilityCriteriaDocuments" :key="index">
                          <div class="col-1">
                            <div class="nottble" style="margin-top: 0px">
                    <div class="chkbox" data-title="Select">
                      <label class="custcheckbox">
                        <input
                        disabled
                          type="checkbox"
                          
                          :checked="data.path"
                        />
                        <span class="checkmarkchk"></span>
                      </label>
                    </div>
                  </div>
                          </div>
                          <div class="col-4">
                              <label>
                                  <span>{{ data.name }} </span>
                              </label>
                          </div>
                          <div class="col-6">
                            <button class="btn btn-doc btn-sm" style="background-color: darkseagreen;" @click.prevent="preViewDocument(data.path)" v-if="data.path">
                              View
                            </button>
                            <button class="btn btn-doc btn-sm" style="margin-left: 10px;background-color: indianred;" @click.prevent="removeDocument(index,data.key)"   v-if="data.path">
                              Delete
                            </button>
                           
                            <input 
                            v-else
                             id="importExportID"
                              type="file"
                              :ref="data.name"
                              :name="data.name"
                              accept="application/pdf, image/jpg, image/png"
                              @change="updateFile(data.apiName,data.name,index)"/>
                            
                             
                          </div>
                          
                      </div>
                </div>
              </div>
            </div>
          <!-- <form data-vv-scope="studentvalidate" id="stuprofile" accept-charset="utf-8">
            <div class="form-row">
               <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                <span class="has-float-label">
                  <input
                    type="text"
                    disabled
                    name="studentFirstName"
                    v-model="contactDetails.className"
                    class="form-control form-input"
                    id="stdFirstName"
                  />
                
                  <label for="stdFirstName" 
                    >Class Name <span class="required">*</span></label
                  >
                </span>
              </div>
              <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                <span class="has-float-label">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="studentFirstName"
                    v-model="contactDetails.firstName"
                    class="form-control form-input"
                    id="stdFirstName"
                  />
                  <label
                    v-if="errors.first('studentvalidate.studentFirstName')"
                    class="vi-error"
                    style="top:-1em"
                    >First name is required</label
                  >
                  <label for="stdFirstName" v-else
                    >First Name <span class="required">*</span></label
                  >
                </span>
              </div>

              <div class="form-group input-group col-md-6 mt-3">
                <span class="has-float-label">
                  <input
                    v-validate="'required'"
                    type="text"
                    name="studentLastName"
                    v-model="contactDetails.lastName"
                    class="form-control form-input"
                    id="stdLastName"
                  />
                  <label
                    v-if="errors.first('studentvalidate.studentLastName')"
                    class="vi-error"
                    style="top:-1em"
                    >Last name is required</label
                  >
                  <label for="stdLastName" v-else
                    >Last Name<span class="required">*</span></label
                  >
                </span>
              </div>
              <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                <span class="has-float-label">
                  <input
                    type="text"
                    name="stdEmail"
                    v-model="contactDetails.email"
                    class="form-control form-input"
                    id="stdEmail"
                  />
                  <label for="stdEmail"
                    >Secondary Email</label
                  >
                </span>
              </div>
             
              <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                <span class="has-float-label">
                  <input
                   v-validate="'required'"
                    type="date"
                    onkeydown="return false"
                    name="DOB"
                    v-model="contactDetails.dob"
                    class="form-control form-input"
                    id="stdDob"
                  />
                  <label
                    v-if="errors.first('studentvalidate.DOB')"
                    class="vi-error"
                    style="top:-1em"
                    >Date of birth is required</label
                  >
                 
                 
                  <label for="stdDob" v-else
                    >Date of Birth <span class="required">*</span></label
                  >
                </span>
              </div>
              
              <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                <span class="has-float-label">
                  <select
                    v-validate="'required'"
                    name="Blood Group"
                    class="form-control form-input"
                    id="bloodGroup"
                    v-model="contactDetails.bloodGroup"
                  >
                    <option :value="null">-- Select --</option>
                    <option
                      v-for="(blood, index) in bloodGroupList"
                      :key="index"
                      :value="blood"
                    >
                      {{ blood }}
                    </option>
                  </select>
                  <label
                    v-if="errors.first('studentvalidate.Blood Group')"
                    class="vi-error"
                    style="top:-1em"
                    >Blood group is required</label
                  >
                  <label for="bloodGroup" v-else
                    >Blood Group <span class="required">*</span></label
                  >
                </span>
              </div>
              

                  <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <select
                            v-validate="'required'"
                            name="gender"
                            class="form-control form-input"
                            id="gender"
                            v-model="contactDetails.gender"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(item, index) in genderList"
                              :key="index"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                          <label
                            v-if="errors.first('studentvalidate.gender')"
                            class="vi-error"
                            style="top:-1em"
                            >Gender is required</label
                          > 
                          <label for="firstName" v-else
                            >Gender <span class="required">*</span></label
                          >
                        </span>
                      </div>
              <fieldset class="accordion-group-container">
                <div >
                 
                  <label
                    style="margin: 0"
                    for="accordiongroup-1"
                    class="blutitle accordion-label"
                  >
                    Parent Details
                  </label>
                    <div class="form-row">
                       <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <select
                            v-validate="'required'"
                            name="pointOfContact"
                            class="form-control form-input"
                            id="pointOfContact"
                            v-model="contactDetails.pointOfContact"
                          >
                            <option :value="null">-- Select --</option>
                            <option
                              v-for="(item, index) in pointOfList"
                              :key="index"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                          <label
                            v-if="errors.first('studentvalidate.pointOfContact')"
                            class="vi-error"
                            style="top:-1em"
                            >Point of contact is required</label
                          > 
                          <label for="firstName" v-else
                            >Point of contact <span class="required">*</span></label
                          >
                        </span>
                      </div>
                      
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label" v-if="contactDetails.pointOfContact == 'Father'">
                          <input
                            type="text"
                            name="fthrname"
                            disabled
                            v-model="userDetails.firstName"
                            class="form-control form-input"
                            id="fthrnameid"
                            placeholder="Father Name"
                          />
                          <label for="fthrnameid" 
                            >Father Name <span class="required">*</span></label
                          >
                        </span>
                         <span class="has-float-label" v-if="contactDetails.pointOfContact == 'Mother'">
                          <input
                            type="text"
                            name="Mother"
                            disabled
                            v-model="userDetails.firstName"
                            class="form-control form-input"
                            id="Mother"
                            placeholder="Mother Name"
                          />
                          <label for="fthrnameid" 
                            >Mother Name <span class="required">*</span></label
                          >
                        </span>
                         <span class="has-float-label" v-if="contactDetails.pointOfContact == 'Guardian'">
                          <input
                            type="text"
                            name="Guardian"
                            disabled
                            v-model="userDetails.firstName"
                            class="form-control form-input"
                            id="Guardian"
                            placeholder="Guardian Name"
                          />
                          <label for="Guardian" 
                            >Guardian Name <span class="required">*</span></label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-6 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="occ"
                            disabled
                            v-model="userDetails.occupation"
                            class="form-control form-input"
                            id="occid"
                            placeholder="Occupation"
                          />
                          <label for="occid"
                            >Occupation </label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="Religion"
                            disabled
                            v-model="userDetails.religion"
                            class="form-control form-input"
                            id="relid"
                            placeholder="Religion"
                          />
                          <label for="relid"
                            >Religion </label
                          >
                        </span>
                        
                      </div>

                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            disabled
                            name="nationality"
                            v-model="userDetails.nationality"
                            class="form-control form-input"
                            id="natid"
                            placeholder="Nationality"
                          />
                          <label for="natid"
                            >Nationality </label
                          >
                        </span>
                      </div>

                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            type="email"
                            disabled
                            name="ptemail"
                            v-model="userDetails.email"
                            class="form-control form-input"
                            id="ptemailid"
                            placeholder="Email"
                          />
                          <label for="ptemailid" 
                            >Primary Email <span class="required">*</span></label
                          >
                        </span>
                      </div>
                      <div class="form-group input-group col-md-6 pr-md-3 mt-3">
                        <span class="has-float-label">
                          <input
                            maxlength="10"
                            disabled
                            name="ptph"
                            v-model="userDetails.phoneNo"
                            class="form-control form-input"
                            id="ptphid"
                            placeholder="Phone"
                          />
                         
                          <label  for="ptphid">Phone <span class="required">*</span></label>
                        </span>
                      </div>

                      <div class="form-group input-group col-md-6 mt-3">
                        <span class="has-float-label">
                          <input
                            type="text"
                            name="stadr"
                            disabled
                            v-model="userDetails.address"
                            class="form-control form-input"
                            id="stadrid"
                            placeholder="Address Details"
                          />
                          <label for="stadrid"
                            >Address Details</label
                          >
                        </span>
                      </div>
                    </div>
                    <div class="form-group row" v-for="(data, index) in contactDetails.eligibilityCriteriaDocuments" :key="index">
                          <div class="col-1">
                              <div class="radios">
                                  <div class="row">
                                      <div class="form-check col-3">
                                          <input class="styled-checkbox" id="NIC" type="checkbox" :checked="data.path" disabled>
                                          <label class="abs-position" for="NIC"></label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-4">
                              <label>
                                  <span>{{ data.name }} <span class="required">*</span></span>
                              </label>
                          </div>
                          <div class="col-6">
                            <button class="btn btn-doc btn-sm" style="background-color: darkseagreen;" @click.prevent="preViewDocument(data.path)" v-if="data.path">
                              View
                            </button>
                            <button class="btn btn-doc btn-sm" style="margin-left: 10px;background-color: indianred;" @click.prevent="removeDocument(index,data.key)"   v-if="data.path">
                              Delete
                            </button>
                           
                           
                            <input 
                            v-else
                              type="file"
                              :ref="data.name"
                              :name="data.name"
                              accept="application/pdf, image/jpg, image/png"
                              @change="updateFile(data.apiName,data.name)"/>
                            
                             
                          </div>
                          
                      </div>
                </div>

              </fieldset>

            </div>
            <div
              class="dispflex mt-3 pt-3"
              style="border-top: 1px solid #e5e5e5"
            >
              <div class="dk_icon">
               
              </div>
              <div class="text-right dk_iconsml">
                
               
                 <button 
                  type="button"
                  class="btn btnsml"
                  id="svbtn"
                  @click.prevent="submitApplication"
                >
                  <i class="far fa-save"></i> <span>Save</span>
                </button>
                <button type="button" @click.prevent="closePoup" class="btn btncl clsmdl" id="clbtn">
                  <i class="far fa-times-circle"></i> <span>Cancel</span>
                </button>
              </div>
            </div>
          </form> -->
        </div>
      </div>
    </b-modal>
    <b-modal id="reviewPopUp" class="modal" no-close-on-backdrop no-close-on-esc>
      <div class="contact-form">
        <h2>Reviews </h2>
        <br />
        <div style="height: 350px; overflow-y: auto">
          <form data-vv-scope="studentvalidate" id="stuprofile" accept-charset="utf-8">
            <div class="row" v-for="(data, index) in parentReviewList" :key="index">
              <div class="col-2">
                <div class="white-box" >
                              <div class="no-blu no-cirlce">
                                            {{ data.parent ? data.parent.firstName.charAt(0) : "" }}{{ data.parent ? data.parent.lastName.charAt(0) : "" }}
                              </div>
                               </div>
                </div>
                <div class="col-10">
                   <table class="table text-nowrap">
                            <tbody>
                              <tr>
                                <td style="width: 11%;">Name:</td>
                                <td >
                                 {{ data.parent.firstName }}
                                </td>
                               
                              </tr>
                              <tr>
                                <td>Date:</td>
                                <td >
                                 {{ data.updatedDate | dateFormat }}
                                </td>
                               
                              </tr>
                              <tr>
                                <td>Ratings:</td>
                                <td >
                                  <star-rating
                                :star-size="20"
                                :show-rating="false"
                                inactive-color="#666"
                                active-color="#ffa500"
                                :rating="data.overAllRating"
                                :clearable="false"
                                :increment="0.5"
                                :read-only="true"
                                class="vi-r-review"
                              />
                                </td>
                               
                              </tr>
                              
                             
                              <tr>
                                <td>Comments</td>
                                <td>{{ data.comment }}</td>
                              </tr>
                            </tbody>
                          </table>
                </div>
              
                    <!-- <div class="col-12" v-for="(data, index) in parentReviewList" :key="index" >
                      <div class="kids-details-box mb-3" v-if="index == 0 || index == 1 || index == 2">
                        <div
                          class="has-float-label"
                          
                        >
                          <div class="schlogo">
                            
                             <div class="white-box" >
                              <div class="no-blu no-cirlce">
                                            {{ data.parent ? data.parent.firstName.charAt(0) : "" }}{{ data.parent ? data.parent.lastName.charAt(0) : "" }}
                              </div>
                             </div>
                            
                            
                         
                          </div>
                        </div>
                        
                        <div class="item-content">
                          <table class="table text-nowrap">
                            <tbody>
                              <tr>
                                <td>Name:</td>
                                <td >
                                 {{ data.parent.firstName }}
                                </td>
                               
                              </tr>
                              <tr>
                                <td>Date:</td>
                                <td >
                                 {{ data.updatedDate | dateFormat }}
                                </td>
                               
                              </tr>
                              
                             
                              <tr>
                                <td>Comments</td>
                                <td>{{ data.comment }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div> -->
                    
                  </div>
            <div
              class="dispflex mt-3 pt-3"
              style="border-top: 1px solid #e5e5e5"
            >
              <div class="dk_icon">
               
              </div>
              <div class="text-right dk_iconsml">
                
               
                
                <button type="button" @click.prevent="closeReviewPoup" class="btn btncl clsmdl" id="clbtn">
                  <i class="far fa-times-circle"></i> <span>Cancel</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
  
</template>


<script>
import "vue-awesome/icons/arrow-left";
import ViSpinner from "../Common/ViSpinner";
import ViService from "@/services/ViService";
import errorLog from "@/utils/errorLog";
import secureUI from "../../utils/secureUI";
import StarRating from "vue-star-rating";
export default {
  name: "vi-school-overview",
  components: {
    ViSpinner,
    StarRating,
  },
  props: ["swapComponent"],
  data() {
    return {
      overviewHight: false,
      isPayment: '',  
      section: 0,
      viLoader: true,
      schoolData: null,
      admissionSelect: 'aOn',
      infrastructure: null,
      academics: null,
      sports: null,
      faculty: null,
      safety: null,
      message: null,
      messageError: null,
      rateError: null,
      classList: [],
      currentPopUpTab: 1,
      academicYearList: [],
      galleryList: [],
      stateList: [
         "Andaman and Nicobar Islands",
        "Andhra Pradesh",
         "Arunachal Pradesh",
         "Assam",
         "Bihar",
         "Chandigarh",
         "Chhattisgarh",
         "Dadra and Nagar Haveli",
         "Daman and Diu",
         "Delhi",
         "Goa",
         "Gujarat",
         "Haryana",
         "Himachal Pradesh",
         "Jammu and Kashmir",
         "Jharkhand",
         "Karnataka",
         "Kerala",
         "Lakshadweep",
         "Madhya Pradesh",
         "Maharashtra",
         "Manipur",
         "Meghalaya",
         "Mizoram",
         "Nagaland",
         "Odisha",
         "Puducherry",
         "Punjab",
         "Rajasthan",
         "Sikkim",
        "Tamil Nadu",
        "Telangana",
         "Tripura",
         "Uttar Pradesh",
         "Uttarakhand",
         "West Bengal",
      ],
      bloodGroupList: ["A+", "O+", "B+", "AB+", "A-", "O-", "B-", "AB-"],
      facilitiesURL: process.env.BASE_URL + "facilities",
      admissionDetails: [],
      contactDetails: {
        middleName : "",
        fatherFirstName : "",
        fatherLastName : "",
        fatherOccuption : "",
        motherFirstName : "",
        motherLastName : "",
        motherOccuption : "",
        guardianFirstName : "",
        guardianLastName : "",
        guardianOccuption : "",
        mobileThree: null,
        isPermentAddress: false,
        isrtequota: false,
        isDisability: false,
        permentaddressOne  : "",
        permentaddressTwo : "",
        permentstate : "",
        permentdistrict : "",
        permentpostalCode : "",
        permentcountry : "",
        category : "",
        previousSchool : "",
        lastSchoolGrade: '',
        lastSchoolCity: '',
        lastSchoolCountry: '',
        previousClassPassed : "",
        firstName: "",
        lastName: "",
        admissionType: "online",
        dob: null,
        doj: null,
        dateOfLeaving: null,
        pointOfContact: 'Father',
        academicYear: null,
        gender: "Male",
        parentId: null,
        accountId: null,
        email: "",
        mobileOne: 0,
        mobileTwo: 0,
        image: "",
        addressOne: "",
        addressTwo: "",
        state: "",
        district: "",
        postalCode: "",
        country: "",
        classApplied: "",
        bloodGroup: null,
        admissionStatus: 'Submitted',
        siblings: false,
        rollNoAllocated: "",
        class: null,
        branchId: null,
        classSection: null,
        parentId: null,
        siblingName: null,
        siblingRollNo: "",
        siblingDiscount: '',
        className: '',
        admissionDeadline: null,
        eligibilityCriteria: [],
        placeofBirth: '',
        aadharNo: '',
        studentPhoneNumber: null,
        otherLanguage: '',
      },

      userDetails: {
        firstName: "",
        lastName: "",
        fatherName: "",
        motherName: "",
        email: "",
        phoneNo: null,
        password: "",
        role: "",
        membership: "Free",
        userId: "",
        gender: "",
        occupation: "",
        religion: "",
        nationality: "",
        address: "",
        registeredAs: "",
        userDevices: [],
        profile: null,
      },
      parentReviewList: [],
      adminReview: {
            infrastructure: 0,
            sports: 0,
            facilities: 0,
            management: 0,
            faculty: 0,
            safety: 0
      },
      parentReview: {
            infrastructure: 0,
            sports: 0,
            facilities: 0,
            management: 0,
            faculty: 0,
            safety: 0
      },
      enrollmentStatusList: [
        "Active",
        "Inactive",
        "Submit", 
        "In Review",
        "Assessment",
        "Approved", 
        "Reject", 
        "Enrolled"
      ],
       facilitiesList: [
        "Co-Education",
        "Medical Facilities",
        "Hostel",
        "School Library",
        "Computer Lab",
        "Sports",
        "Cafeteria",
        "Disabled Friendly",
        "Transport Facilities",
        "AC Class rooms",
        "Smart Classrooms",
        "Restaurant",
        "Transport",
        "School bus",
        "Technology",
        "Anti Bulling",
        "Science Park",
        "Science Laboratory",
        "Computer Laboratory",
        "Robotics",
        "Math Laboratory",
        "English Laboratory",
        "Library",
        "Safety & Security",
      ],
      checkedBoardType: [],
      checkedschoolType: [],
      checkedFacilities: [],
      checkedMediumType: [],
      checkedClass: [],
      checkedState: [],
      
      pointOfList: [
       'Father',
       'Mother',
       'Guardian'
      ],
      genderList: [
       'Male',
       'Female'
      ]
    };
  },
  
  computed: {
    filteredSchool() {
      this.sList = this.$store.getters.schoolListObject;
       let filterSchoolList = [];

      if(this.sList.length == 0){
        let requestBody = {
        schoolName: null,
        category: null,
        city: null,
        accountId: this.$route.query.accId,
        branchId: this.$route.query.branchId
      };
      ViService.viPost("/app/school/commonSearch/parentPortal", requestBody)
        .then((res) => {
          if (res.isSuccess) {

            let data = secureUI.secureGet(res.data);
            if (data && data.length > 0) {
              this.$store.dispatch("setSchoolList", data);
              filterSchoolList = data
            } 
            // else {
            //   this.$toasted.error("Records not found");
            // }
          } else {
            this.$toasted.error(res.message);
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
      }else{
       filterSchoolList = this.sList;
      }
      //       const letters = new Set();


      //  if (this.checkedBoardType.length > 0) {
      //   let cloneList = []
      //   for(let x of filterSchoolList){
      //     if(x.affilliateIdToBoard && x.affilliateIdToBoard.length > 0){
      //       for(let y of x.affilliateIdToBoard){
      //         if(this.checkedBoardType.includes(y)){
      //           letters.add(x)
      //         }

      //       }
      //     }
      //   }
      //   const allTermList = [];
      //   for (let x of letters) {
      //     allTermList.push(x);
      //   }

      //   filterSchoolList = allTermList
      // }

      // if(this.checkedschoolType.length > 0) {
      //   filterSchoolList = filterSchoolList.filter((s) =>
      //     this.checkedschoolType.includes(s.schoolType)
      //   );
      // }
      
      // if (this.checkedMediumType.length > 0) {

      //   let cloneList = []
      //   for(let x of filterSchoolList){
      //     if(x.medium && x.medium.length > 0){
      //       for(let y of x.medium){
      //         if(this.checkedMediumType.includes(y)){
      //           cloneList.push(x)
      //         }
      //       }
      //     }
      //   }
      //   filterSchoolList = cloneList
      // }
      if (this.checkedFacilities.length > 0) {

        let cloneList = []
        for(let x of filterSchoolList){
          if(x.facilities && x.facilities.length > 0){
            for(let y of x.facilities){
              if(this.checkedFacilities.includes(y.name)){
                cloneList.push(x)
              }
            }
          }
        }
        filterSchoolList = cloneList
      }

      // if (this.checkedState.length > 0) {
      //   filterSchoolList = filterSchoolList.filter((s) =>
      //     this.checkedState.includes(s.state)
      //   );
      // }
      // if (this.checkedDistrict.length > 0) {
      //   filterSchoolList = filterSchoolList.filter((s) =>
      //     this.checkedDistrict.includes(s.city)
      //   );
      // }
      // if(this.checkedClass.length > 0) {
        
      //   var classIndex = this.classList.indexOf(this.checkedClass[0]);
      //   var filteredFromClassList = this.classList.slice(classIndex);

      //   filterSchoolList = filterSchoolList.filter((s) =>
      //     filteredFromClassList.includes(s.gradeFrom)
      //   );

      // }

      return filterSchoolList;
    },
     checkAdmissionAuvaiable() {
      if(this.admissionDetails.length > 0){
        
       const statusCheck = this.admissionDetails.filter( x => x.admissionStatus == 'Open' && x.isShowSearch)
       return statusCheck.length
      }else{
        return 0
      }
      
    }
  },
  created() {
	  this.initmethod()

  },
  mounted(){
    window.addEventListener("scroll", this.onScroll)
  },
  methods: {
    increaseOverViewheight(){
      this.overviewHight = true
    },
     reduceOverViewheight(){
      this.overviewHight = false
    },
   

    async initmethod(){
      await this.getSchoolInfo();
    },
    onScroll(){
      let adfiltsect = document.getElementById("filtersects");
  
  

    if (adfiltsect) {
      if (
        document.body.scrollTop > 70 ||
        document.documentElement.scrollTop > 70
      ) {
        adfiltsect.classList.add("fixed-top");
        adfiltsect.style.top = "0px";
        adfiltsect.style.zIndex = "12";
      } else {
        adfiltsect.classList.remove("fixed-top");
      }
    }
    },
    async getSchoolInfo() {
      ViService.viGetOnly(`/common/details/schoolNameAndAccoutId?accountId=${this.$route.query.accId}&name=${this.$route.query.schoolName}&branch=${this.$route.query.branchId}`)
        .then((res) => {
          if (res.isSuccess) {
            let data = secureUI.secureGet(res.data);
            if (res.data) {
              this.schoolData = data;
              if(this.schoolData){
                //this.schoolData.overView = 'Techparrot Innovations Llp is a Limited Liability Partnership firm incorporated on 18 May 2021. It is registered at Registrar of Companies, Chennai. Its total obligation Techparrot Innovations Llp is a Limited Liability Partnership firm incorporated on 18 May 2021. It is registered at Registrar of Companies, Chennai. Its total obligation Techparrot Innovations Llp is a Limited Liability Partnership firm incorporated on 18 May 2021. It is registered at Registrar of Companies, Chennai. Its total obligation of contribution is Rs. 10,000. Designated Partners of Techparrot Innovations Llp are Vimal Das Adiyeri Cainadath and Juliet Lathika Rajeesh.'
                 this.searchSchoolDetails();
                 this.schoolGallaryList()
                // this.getRatingDetails()
              }
            }
          } else {
            this.$toasted.show(res.message);
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
    },
    setRating(rating, value) {
      value == "infrastructure" ? (this.infrastructure = rating) : null;
      value == "academics" ? (this.academics = rating) : null;
      value == "sports" ? (this.sports = rating) : null;
      value == "faculty" ? (this.faculty = rating) : null;
      value == "safety" ? (this.safety = rating) : null;
    },
    viewSchoolAction(item) {
      this.$store.dispatch("setSchoolInfo", item);
        window.open(`https://app--stage.vidhyaan.com/search-school/overview?schoolName=${item.accountName}&accId=${item.accountId}&branchId=${item._id}`);

     // window.open(`https://app--stage.vidhyaan.com/search-school/overview/?schoolName=${item.accountName}&accId=${item.accountId}`);
    },
    submitRating() {
      let userData = secureUI.sessionGet("user");
      if (!userData) {
        this.$toasted.error("Please login and do the action");
         this.$router.push('/login');
      } else {
        this.$toasted.clear();
     
        if (
          !this.infrastructure ||
          !this.academics ||
          !this.sports ||
          !this.faculty ||
          !this.safety
        ) {
          this.rateError = true;
        } else {
          this.rateError = null;
        }
        if (
          !message &&
          this.infrastructure &&
          this.academics &&
          this.sports &&
          this.faculty &&
          this.safety
        ) {
          let requestBody = {
            accountId: this.schoolData._id,
            parentId: userData.userDetails._id,
            infrastructure: this.infrastructure,
            academics: this.academics,
            sports: this.sports,
            faculty: this.faculty,
            safety: this.safety,
            message: this.message,
            schoolName: "",
            category: "",
            city: "",
          };
          
          this.viLoader = true;
          ViService.viXPost("/rating/school", requestBody, userData.token)
            .then((res) => {
              this.viLoader = null;
              if (res.isSuccess) {
                this.clearMsg();
                this.$toasted.success("Rating submitted successfully");
              } else {
                this.$toasted.error(res.message);
              }
            })
            .catch((e) => {
              this.viLoader = null;
              let eData = errorLog.apiErrorLog(e);
              this.$toasted.error(eData);
            });
        }
      }
    },
     async schoolGallaryList() {
       if(this.schoolData){
        const response = await ViService.viGetOnly(`/common/galleryList?accountId=${this.$route.query.accId}&branchId=${this.$route.query.branchId}`);

      // const response = await ViService.viGetOnly("/common/galleryList?accountId=" + this.schoolData._id);
      // const response = await ViService.viXGet(`/account/galleryList?accountId=${userData.userDetails.account._id}`,userData.token);


        if (response.isSuccess) {
          const details = secureUI.secureGet(response.data); 
          this.galleryList = details.gallery || []
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
     }
    },
     async getRatingDetails() {
     
       if(this.schoolData){
       const response = await ViService.viGetOnly("/common/overAllRating?accountId=" + this.schoolData._id);


        if (response.isSuccess) {
          const details = secureUI.secureGet(response.data); 
          if(details.length > 0){
            const adminReviewDetails = details.filter( x => x.isReviewedByAdmin)
            if(adminReviewDetails.length > 0){
              this.adminReview.infrastructure = adminReviewDetails[0].infrastructure,
              this.adminReview.sports = adminReviewDetails[0].sports,
              this.adminReview.facilities = adminReviewDetails[0].facilities,
              this.adminReview.management = adminReviewDetails[0].management,
              this.adminReview.faculty = adminReviewDetails[0].faculty,
              this.adminReview.safety = adminReviewDetails[0].safety
            }
            const parentReviewDetails = details.filter( x => x.isReviewedByParent && x.status == "Approved")
            if(parentReviewDetails.length > 0){
            this.parentReviewList = parentReviewDetails

            const infrastructureTotal = parentReviewDetails.map(o => o.infrastructure).reduce((a, c) => { return a + c });
            const infrastructureTotalSum = (infrastructureTotal / parentReviewDetails.length).toFixed(2)
            this.parentReview.infrastructure = parseFloat(infrastructureTotalSum)

            const sportTotal = parentReviewDetails.map(o => o.sports).reduce((a, c) => { return a + c });
            const sportTotalSum = (sportTotal / parentReviewDetails.length).toFixed(2)
            this.parentReview.sports = parseFloat(sportTotalSum)

            const facilitiesTotal = parentReviewDetails.map(o => o.facilities).reduce((a, c) => { return a + c });
            const facilitiesTotalSum = (facilitiesTotal / parentReviewDetails.length).toFixed(2)
            this.parentReview.facilities = parseFloat(facilitiesTotalSum)

            const managementTotal = parentReviewDetails.map(o => o.management).reduce((a, c) => { return a + c });
            const managementTotalSum = (managementTotal / parentReviewDetails.length).toFixed(2)
            this.parentReview.management = parseFloat(managementTotalSum)

            const facultyTotal = parentReviewDetails.map(o => o.faculty).reduce((a, c) => { return a + c });
            const facultyTotalSum = (facultyTotal / parentReviewDetails.length).toFixed(2)
            this.parentReview.faculty = parseFloat(facultyTotalSum)

            const safetyTotal = parentReviewDetails.map(o => o.safety).reduce((a, c) => { return a + c });
            const safetyTotalSum = (safetyTotal / parentReviewDetails.length).toFixed(2)
            this.parentReview.safety = parseFloat(safetyTotalSum)
            }

          }
          
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
     }
    },
    
    async submitApplication(){
      let isFormValid = false;

       await this.$validator.validateAll('studentvalidateOne').then(result => {
          isFormValid = result;
       });

      if (isFormValid) {

      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
      
       ViService.viXPost("/contact/commonSearch/parentPortal/apply",this.contactDetails, userData.token)
            .then((res) => {
              if (res.isSuccess) {
                this.$toasted.success(res.message);
                this.contactDetails['_id'] = res.data._id
                this.currentPopUpTab = 3

                if(res.data && res.data.eligibilityCriteriaDocuments && res.data.eligibilityCriteriaDocuments.length > 0){
                this.contactDetails.eligibilityCriteriaDocuments = res.data.eligibilityCriteriaDocuments

                }
              //  this.$router.push("/parent/admission");
                
              } else {
                this.$toasted.error(res.message);
              }
            })
            .catch((e) => {
              let eData = errorLog.apiErrorLog(e);
              this.$toasted.error(eData);
            });
      }
      }
    },
    async saveLastAcademicDetails(){
      let obj = {
        lastSchoolGrade: this.contactDetails.lastSchoolGrade,
        lastSchoolCity : this.contactDetails.lastSchoolCity,
        lastSchoolCountry : this.contactDetails.lastSchoolCountry,
        previousSchool : this.contactDetails.previousSchool
       };
 
       let userData = secureUI.sessionGet("user");
 
       if (!userData) {
         this.$toasted.error("Please login and do the action");
       } else {
         const response = await ViService.viXPut(
           `/admission/updateOnlineAdmission/${this.contactDetails._id}`,
           obj,
           userData.token
         );
 
         if (response.isSuccess) {
           this.currentPopUpTab = 5
 
           this.$toasted.success(response.message);
 
         } else {
           this.$toasted.error(response.message);
           if (response.message == "Your session has expired, please login") {
             localStorage.removeItem("user");
             this.$router.push("/login");
           }
         }
       }
    },
    async updateFile(name,docType,index) {

let userData = secureUI.sessionGet("user");

if (!userData) {
this.$toasted.error("Please login and do the action");
} else {
const docFileDetails = this.$refs[docType][0].files[0]
const fd = new FormData();
fd.append('doc', docFileDetails, docFileDetails.name,docFileDetails.actType);
const response = await ViService.viPutOnly(`/document/parentPortal/uploadFile/${this.contactDetails._id}/${name}`,fd,userData.token);

if (response.isSuccess) {
  this.$toasted.success('Upload Successful');
 // this.getOnlineAdmissionList();
 // contactDetails.eligibilityCriteriaDocuments
//  this.contactDetails.eligibilityCriteriaDocuments = []
//  this.contactDetails.eligibilityCriteriaDocuments = response.data

  // for(let x of eligibilityCriteriaDocuments){
  //         this.contactDetails.eligibilityCriteriaDocuments.push(
  //           {
  //             name: x.name,
  //             apiName: x.apiName,
  //             path: x.path,
  //             key: x.key
  //           }
  //         )}

  //console.log("eligibilityCriteriaDocuments",eligibilityCriteriaDocuments)
  // this.contactDetails.eligibilityCriteriaDocuments[index].path = eligibilityCriteriaDocuments[index].path
  // this.contactDetails.eligibilityCriteriaDocuments[index].key = eligibilityCriteriaDocuments[index].key

   // this.getNewOnlineAdmissionList();
} else {
  this.$toasted.error(response.message);
    if(response.message == 'Your session has expired, please login'){
        localStorage.removeItem('user');
        this.$router.push('/login');
  }
}
 //document.getElementById("importExportID").value=null; 

}

},
async getOnlineAdmissionList() {
      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      this.$router.push('/login');
      } else {
        const response = await ViService.viXGet(
          `/admission/getParentOnlineAdmissionListView?parentId=${userData.userDetails._id}`,
          userData.token
        );
        if (response.isSuccess) {
          let onlineAdmissionList = secureUI.secureGet(response.data);
        //  let getdata = onlineAdmissionList.find()
          this.$toasted.success(response.message);
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      }
    },
    async saveContactAddress(){

      let obj = {
       
      permentpostalCode: this.contactDetails.permentpostalCode,
      permentdistrict : this.contactDetails.permentdistrict,
      permentstate : this.contactDetails.permentstate,
      permentcountry : this.contactDetails.permentcountry,
      permentaddressTwo : this.contactDetails.permentaddressTwo,
      permentaddressOne : this.contactDetails.permentaddressOne,
      postalCode : this.contactDetails.postalCode,
      district : this.contactDetails.district,
      state : this.contactDetails.state,
      country : this.contactDetails.country,
      addressTwo : this.contactDetails.addressTwo,
      addressOne : this.contactDetails.addressOne,
      isPermentAddress: this.contactDetails.isPermentAddress

      };

      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
        const response = await ViService.viXPut(
          `/admission/updateOnlineAdmission/${this.contactDetails._id}`,
          obj,
          userData.token
        );

        if (response.isSuccess) {
          this.currentPopUpTab = 4

          this.$toasted.success(response.message);

        } else {
          this.$toasted.error(response.message);
          if (response.message == "Your session has expired, please login") {
            localStorage.removeItem("user");
            this.$router.push("/login");
          }
        }
      }
    },
    applyAdmissionOnline(index){
        let userData = secureUI.sessionGet("user");
        
        if (!userData) {
          this.$toasted.error("Sign-Up/Login to the Vidhyaan Portal to Apply for Admission");
          this.$router.push('/login');
        } else {

          if(userData.userDetails.profile && userData.userDetails.profile.name == 'Parent'){

              const userinfromation  = userData.userDetails
              this.userDetails.firstName = userinfromation.firstName,
              this.userDetails.email = userinfromation.email || '',
              this.userDetails.phoneNo = userinfromation.phoneNo || '',
              this.userDetails.occupation = userinfromation.occupation || '',
              this.userDetails.religion = userinfromation.religion || '',
              this.userDetails.nationality = userinfromation.nationality || '',
              this.userDetails.address = userinfromation.address || ''
              this.contactDetails.parentId = userinfromation._id || ''

              const classDetails = this.admissionDetails[index]
              
              this.contactDetails.parentId = userinfromation._id || ''
              this.contactDetails.className = classDetails.class ? classDetails.class.className : ''
              this.contactDetails.class = classDetails.class ? classDetails.class._id : ''
              this.contactDetails.academicYear = classDetails.academicYear
              this.contactDetails.accountId = this.schoolData.accountId
              this.contactDetails.admissionDeadline = classDetails.admissionDeadline
              this.contactDetails.eligibilityCriteria = classDetails.eligibilityCriteria
              this.contactDetails.eligibilityCriteriaDocuments = []
              
              this.contactDetails.branchId = this.schoolData._id

              //contactDetails.eligibilityCriteria
        //       for(let x of this.contactDetails.eligibilityCriteria){
        //   this.contactDetails.eligibilityCriteriaDocuments.push(
        //     {
        //       name: x,
        //       apiName: x.replace(/\s/g, '_'),
        //       path: '',
        //       key: ''
        //     }
        //   )
        // }

              this.$bvModal.show("addstudpop");

          }else{
            this.$toasted.error('Access restricted for school admin');
          }
       
        }
    },
    closePoup(){
     this.$bvModal.hide("addstudpop");
    // this.clearForm();
   // this.currentTab = 1;
      // this.isEdit = true
      // this.isShowEditIcon = false

      this.currentPopUpTab = 1
     // this.$bvModal.show("newstudpop");
     // this.currentTab = 1;
    },
    closeReviewPoup(){
     this.$bvModal.hide("reviewPopUp");
    },
    
    clearForm(){

        this.contactDetails.firstName = "";
        this.contactDetails.lastName = "";
        this.contactDetails.admissionType = "online";
        this.contactDetails.dob = null;
        this.contactDetails.academicYear = null;
        this.contactDetails.gender = "Male";
        this.contactDetails.parentId = null;
        this.contactDetails.accountId = null;
        this.contactDetails.email = "";
        this.contactDetails.mobileOne = 0;
        this.contactDetails.mobileTwo = 0;
        this.contactDetails.image = "";
        this.contactDetails.addressOne = "";
        this.contactDetails.addressTwo = "";
        this.contactDetails.state = "";
        this.contactDetails.district = "";
        this.contactDetails.postalCode = "";
        this.contactDetails.country = "";
        this.contactDetails.classApplied = "";
        this.contactDetails.bloodGroup = null;
        this.contactDetails.admissionStatus = 'Active';
        this.contactDetails.siblings = false;
        this.contactDetails.rollNoAllocated = "";
        this.contactDetails.class = null;
        this.contactDetails.classSection = "";
        this.contactDetails.siblingName = "";
        this.contactDetails.siblingRollNo = "";
        this.contactDetails.siblingDiscount = '';
        this.contactDetails.eligibilityCriteria = [];
        this.userDetails.firstName = "";
        this.userDetails.lastName = "";
        this.userDetails.fatherName = "";
        this.userDetails.motherName = "";
        this.userDetails.email = "";
        this.userDetails.phoneNo = null;
        this.userDetails.password = "";
        this.userDetails.role = "";
        this.userDetails.membership = "Free";
        this.userDetails.userId = "";
        this.userDetails.gender = "";
        this.userDetails.occupation = "";
        this.userDetails.religion = "";
        this.userDetails.nationality = "";
        this.userDetails.address = "";
        this.userDetails.registeredAs = "";
        this.userDetails.userDevices = [];
        this.userDetails.profile = null,
        this.userId = null,
        this.editId = null,
        this.feesNotPaid = false
    },
    clearMsg() {
      this.infrastructure = 0;
      this.academics = 0;
      this.sports = 0;
      this.faculty = 0;
      this.safety = 0;
      this.message = null;
    },
    setPopUpActiveTab(index) {
      this.currentPopUpTab = index;
    

    },
    searchSchoolDetails(){
        if(this.schoolData){
       ViService.viGetOnly(`/common/getSearchSchoolFeesDetail?branchId=${this.schoolData._id}&accountId=${this.schoolData.accountId}`)
        .then((res) => {
          if (res.isSuccess) {
            let data = secureUI.secureGet(res.data);
            if (res.data) {
             this.admissionDetails = data;
            }
          } else {
            this.$toasted.show(res.message);
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
        }
    },
  },
  filters: {
    averageRating: function(value) {
      if (!value) return "";
      let totalSum = 0;
      for (let key in value) {
        if (value.hasOwnProperty(key)) {
          totalSum += value[key];
        }
      }
      let val = (totalSum / 6).toFixed(1);
      return parseFloat(val);
    },
    removeURLPrefix: function(value) {
      if (!value) return "";
      value = value.trim();
      return value.replace(/(^\w+:|^)\/\//, "");
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
  },
};
</script>

<style>
.vi-r-review,
.vi-w-review {
  display: inline-block;
}
#addstudpop .modal-content {
    height: 1000% !important; /* Could be more or less, depending on screen size */
	
}
</style>
